import { render, staticRenderFns } from "./AddDrugCategory.vue?vue&type=template&id=62e9482c&"
import script from "./AddDrugCategory.vue?vue&type=script&lang=js&"
export * from "./AddDrugCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports